import inceptionService from './services/inception.service';
import TeamRequestDataService from './services/teamRequestData.service';
import vacationDataService from './services/vacationsUserData.service';
import employeeRepositoryService from './employeeRepository/employeeRepository.service';
import InitialDataService from './initialData/initialData.service';
import managerRepositoryService from './managerRepository/managerRepository.service';
import InitialDataManagerService from './initialData/initialDataManager.service';
import vacationDelegationService from './delegationRepository/vacationDelegationRepository.service';
import periods from './filters/periods';
import modalsBehaviourService from './services/modalsBehaviour.service';
import TeamCalendarService from './services/teamCalendar.service';

let vacationsAbsencesCommon = angular.module('vacations-absences.common', [])

  .service('inceptionService', inceptionService)
  .service('vacationTeamRequestDataService', TeamRequestDataService)
  .service('vacationUserDataService', vacationDataService)
  .service('vacationInitialDataService', InitialDataService)
  .service('vacationEmployeeRepositoryService', employeeRepositoryService)
  .service('vacationManagerRepositoryService', managerRepositoryService)
  .service('vacationInitialDataManagerService', InitialDataManagerService)
  .service('vacationDelegationService', vacationDelegationService)
  .service('modalsBehaviourService', modalsBehaviourService)
  .service('teamCalendarService', TeamCalendarService)

  .filter('filterPeriods', periods)

  .name;

export default vacationsAbsencesCommon;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/vacations-absences.common.js